import React from 'react';
import { Grid } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import styled from 'styled-components';
import DeleteIcon from '@material-ui/icons/Delete';

import { API_ROOT } from '../../../../../../../api/Routes';

const AddImageWrapper = styled.div`
  padding: 0 1rem 0 0.4375rem;
  font-size: 1rem;
  display: inline-flex;
  font-weight: bold;
`;
const AddImageBlockWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  padding-bottom: 0.4375rem;
`;

const AddCriteriaWrapper = styled.div`
  padding: 0 1rem 0 0.4375rem;
  font-size: 1rem;
  display: inline-flex;
  font-weight: bold;
`;
const Image = styled.img`
  height: 100%;
  width: 100%;
`;

const ButtonWrapper = styled.div`
  color: #fff;
  background-color: #37474f;
  border-radius: 100%;
  width: ${props => props.diameter};
  height: ${props => props.diameter};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  cursor: pointer;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.2),
    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12);
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  &:hover {
    background-color: #ffca28;
  }
`;
const ImageContainer = styled.div`
  position: relative;
`;

const DeleteImage = styled(Fab)`
  position: absolute !important;
  top: -15px;
  right: -15px;
  width: 40px !important;
  height: 40px !important;
`;

const ImageWrapper = styled(Grid)`
  margin-top: 10px !important;
  &:nth-child(2) {
    padding-left: 20px;
  }
  &:nth-child(1) {
    padding-right: 20px;
  }
`;

let imgCount = 0;
class GroupAddButtons extends React.Component {
  render() {
    const {
      initialStateValuesForCreateTicket,
      trigerDeleteImage,
      disableButton,
      isEdit,
      // handleOpenAddNewCriteriaDialog,
      showImages,
    } = this.props;

    const keptImgIds = this.props.keptImgIds;
    const newImgFiles = this.props.newImgFiles;
    imgCount = 0;
    return (
      <Grid
        item
        xs={12}
        // md={6}
        className="alignItemCenter"
      >
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="center"
        >
          {showImages && (
            <React.Fragment>
              <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="center"
              >
                {newImgFiles.map((img, index) => {
                  const showImageIndex = newImgFiles.length - 1 - index;
                  imgCount++;
                  if (imgCount < 3) {
                    return (
                      <ImageWrapper
                        key={
                          newImgFiles[showImageIndex].lastModified +
                          showImageIndex
                        }
                        item
                        xs={6}
                      >
                        <ImageContainer>
                          <Image src={newImgFiles[showImageIndex].url} />

                          <DeleteImage
                            aria-label="Delete"
                            onClick={trigerDeleteImage(showImageIndex, 'new')}
                          >
                            <DeleteIcon />
                          </DeleteImage>
                        </ImageContainer>
                      </ImageWrapper>
                    );
                  }
                  return null;
                })}
                {keptImgIds.map((imgId, index) => {
                  imgCount++;
                  if (imgCount < 3) {
                    return (
                      <ImageWrapper key={imgId} item xs={6}>
                        <ImageContainer>
                          <Image src={`${API_ROOT}/asset/${imgId}`} />
                          <DeleteImage
                            aria-label="Delete"
                            onClick={trigerDeleteImage(index, 'existing')}
                          >
                            <DeleteIcon />
                          </DeleteImage>
                        </ImageContainer>
                      </ImageWrapper>
                    );
                  }
                  return null;
                })}
              </Grid>
            </React.Fragment>
          )}

          {!showImages && (
            <React.Fragment>
              <Grid item>
                <AddImageBlockWrapper>
                  <AddImageWrapper>Add image</AddImageWrapper>
                  <ButtonWrapper diameter="50px">
                    {/*<Fab color="secondary" aria-label="Add">*/}
                    <AddIcon />
                    <input
                      disabled={disableButton}
                      className={'hide-native-file-upload-custom'}
                      name="criteriaImage"
                      type="file"
                      onChange={(event) => this.props.onFileUpload(event)}
                      accept="image/*"
                    />
                    {/*</Fab>*/}
                  </ButtonWrapper>
                </AddImageBlockWrapper>
              </Grid>
              {/* <Grid item>
                <AddImageBlockWrapper
                  onClick={() => handleOpenAddNewCriteriaDialog()}
                >
                  <AddCriteriaWrapper>
                    Add search requirements
                  </AddCriteriaWrapper>
                  <ButtonWrapper diameter="35px">
                    <AddIcon className="icon-font-size-small" />
                  </ButtonWrapper>
                </AddImageBlockWrapper>
              </Grid> */}
            </React.Fragment>
          )}
        </Grid>
      </Grid>
    );
  }
}

export default GroupAddButtons;
